class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText1 = 'Buy 2 products to get 10% off!';
    static freeShippingText2 = 'Buy 3 products to get 20% off!';
    static freeShippingText3 = 'You unlocked the 20% discount! Enjoy shopping!';
    static freeShippingDefaultText = 'Add items to your cart to unlock offers!';
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        const cartItemCount = cart.item_count;

        // Calculate progress based on cart item count
        let freeShipBar = 0;
        if (cartItemCount === 1) {
            freeShipBar = 17; // 0% for 1 item
        } else if (cartItemCount === 2) {
            freeShipBar = 50; // 50% for 2 items
        } else if (cartItemCount >= 3) {
            freeShipBar = 100; // 100% for 3 or more items
        }

        const text = this.getText(cartItemCount);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartItemCount) {
        let text;

        if (cartItemCount === 0) {
            this.progressBar.classList.add('progress-hidden');
            text = `<span>${FreeShippingMeter.freeShippingDefaultText}</span>`;
        } else if (cartItemCount === 1) {
            this.progressBar.classList.remove('progress-hidden');
            text = `<span>${FreeShippingMeter.freeShippingText1}</span>`;
        } else if (cartItemCount === 2) {
            this.progressBar.classList.remove('progress-hidden');
            text = `<span>${FreeShippingMeter.freeShippingText2}</span>`;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            text = `<span>${FreeShippingMeter.freeShippingText3}</span>`;
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free';
        }

        return classLabel;
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');
        if (classLabel !== 'none') {
            this.progressBar.classList.add(classLabel);
        }
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            // Update progress bar width
            this.progressMeter.style.width = `${freeShipBar}%`;

            // Update progress text if enabled
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text');
                if (textWrapper) textWrapper.innerHTML = `${freeShipBar}%`;
            }

            // Update the message element
            this.messageElement.innerHTML = text;

            // Handle currency conversion if applicable
            if ((window.show_multiple_currencies && typeof Currency !== 'undefined' && Currency.currentCurrency !== shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400);
    }
}

// Register the custom element
window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
});
